<template>
    <div>
        <vs-table class="mt-8 mb-8" :data="return_stock" v-if="return_stock.length > 0">

            <template slot="header">
                <h5 class="mb-4">Return Stock</h5>
            </template>

            <template slot="thead">
                <vs-th>DATE/TIME</vs-th>
                <vs-th>RETURN STOCK STATUS</vs-th>
                <vs-th>STOCK QUANTITY (KG)</vs-th>
                <vs-th>QUANTITY REASSIGNED</vs-th>
                <vs-th>QUANTITY SENT TO DISPATCH</vs-th>
                <vs-th>ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :id="`return_${tr_return.id}`" :key="index_return" v-for="(tr_return, index_return) in data">

                    <vs-td>
                        {{ __dateTimeFormatter(tr_return.created_at) }}
                    </vs-td>

                    <vs-td class="text-sm" :data="tr_return.status">
                        {{ tr_return.status }}
                    </vs-td>

                    <vs-td :data="tr_return.quantity">
                        {{ Number(tr_return.quantity).toFixed(4) }}
                    </vs-td>

                    <vs-td class="text-sm" :data="tr_return.is_quantity_reassigned">
                        {{ tr_return.is_quantity_reassigned ? "YES" : "NO" }}
                    </vs-td>

                    <vs-td class="text-sm" :data="tr_return.is_quantity_sent_to_dispatch">
                        {{ tr_return.is_quantity_sent_to_dispatch ? "YES" : "NO" }}
                    </vs-td>

                    <vs-td>
                        <div class="vx-row">
                            <vx-tooltip v-if="tr_return.status === 'QC Pending' && $can('create-return-product-qc-test')"
                                class="flex justify-start mr-2" text="Create Return Stock QC Test" position="top">
                                <vs-button class="flex justify-end"
                                    @click="onClickCreateReturnStockQc(tr_return.id)"
                                    size="small" color="primary" type="border" icon-pack="feather"
                                    icon="icon-plus"></vs-button>
                            </vx-tooltip>
                            <vx-tooltip v-if="tr_return.status === 'QC Pending' && $can('create-return-product-qc-test')"
                                class="flex justify-start mr-2" text="QC Not Required" position="top">
                                <vs-button class="flex justify-end" @click="onClickReturnStockQcNotRequired(tr_return.id)"
                                    size="small" color="warning" type="border" icon-pack="feather"
                                    icon="icon-check"></vs-button>
                            </vx-tooltip>
                        </div>
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
        <create-return-stock-qc-test-pop-up v-on:refreshData="refreshItems" ref="createReturnStockQcTestPopUp" />
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')

import CreateReturnStockQcTestPopUp from '@/components/popups/customer/product-orders/order-return/CreateReturnStockQcTestPopUp.vue';

export default {
    name: 'ReturnStockTable',
    props: {
        return_stock: {
            default: [],
            type: Array
        },
        formulation_type: {
            default: '',
            type: String
        },
        formulation_id: {
            default: '',
            type: Number
        }
    },
    methods: {
        onClickViewReturenStock(id) {
            this.$emit('onClickHighlightReturnStock', id)
        },
        onClickCreateReturnStockQc(return_inventory_id) {
            this.$refs.createReturnStockQcTestPopUp.openPopup(return_inventory_id, this.formulation_type, this.formulation_id)
        },
        async onClickReturnStockQcNotRequired(return_inventory_id) {
            await InventoryRepository.returnStockQcTestNotRequired(return_inventory_id)
            await this.refreshItems()
        },
        refreshItems() {
            this.$emit('refreshData')
        }
    },
    components: {
        CreateReturnStockQcTestPopUp,
    }
}
</script>
<style lang="">
    
</style>